import * as yup from 'yup'

export const periodValidation = yup.object().shape({
    name: yup.string().required('Harus diisi'),
    startPeriodDate: yup
        .date()
        .typeError('Tanggal harus valid')
        .required('Harus diisi')
        .max(yup.ref('endPeriodDate'), 'Tanggal mulai tidak bisa lebih besar dari tanggal akhir'), // Ensure startPeriodDate is before endPeriodDate
    endPeriodDate: yup
        .date()
        .typeError('Tanggal harus valid')
        .required('Harus diisi')
        .min(yup.ref('startPeriodDate'), 'Tanggal akhir harus lebih besar dari tanggal mulai'), // Ensure endPeriodDate is after startPeriodDate
    finalizationDeadline: yup
        .date()
        .typeError('Tanggal harus valid')
        .required('Harus diisi')
        .min(yup.ref('endPeriodDate'), 'Batas waktu finalisasi harus setelah tanggal akhir periode'), // Ensure finalizationDeadline is after endPeriodDate
    isActive: yup
        .boolean()
        .oneOf([true, false], 'Isi harus aktif atau tidak aktif')
        .required('Harus diisi'),
}).required();